import { prop, ifElse, identity, always, pipe, find } from "ramda";

export const getMainDataStream = pipe(
  prop("dataStreams"),
  ifElse(identity, find(prop("isMainDataStream")), always(null))
);

// Now this is the same thing
export const getEquipment = getMainDataStream;
